import React, { useState, useReducer } from 'react';
import { saveBookmarks } from './service/storage-service';
import IBookmark from './types/IBookmark';
import { Auth } from './components/auth/Auth';
import { Bookmarks } from './components/bookmarks/Bookmarks';
import { Navbar } from './components/navbar/Navbar';

const App: React.FC<Record<string, never>> = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  // Accepts a new list or an updater function, so callbacks holding stale
  // closures (e.g. the share dialog) can't wipe the list.
  const [bookmarks, setBookmarks] = useReducer(
    (
      prevState: IBookmark[],
      action: IBookmark[] | ((prev: IBookmark[]) => IBookmark[]),
    ) => {
      const newState =
        typeof action === 'function' ? action(prevState) : action;
      saveBookmarks(newState);
      return newState;
    },
    [],
  );

  return (
    <div className="App">
      <Navbar
        menuOpen={menuOpen}
        onToggle={() => setMenuOpen(!menuOpen)}
        sync={<Auth bookmarks={bookmarks} onBookmarksLoad={setBookmarks} />}
      />
      <div className="section pt-05">
        <div className="container">
          <Bookmarks
            bookmarks={bookmarks}
            onBookmarksChange={setBookmarks}
            menuOpen={menuOpen}
            onMenuClose={() => setMenuOpen(false)}
          />
        </div>
      </div>
    </div>
  );
};

export default App;
